import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload5 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 414,
	height: 481,
	viewBox: "0 0 414 481",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		opacity: .6,
		clipPath: "url(#clip0_353_7724)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M197.713 234.755C161.121 212.204 118.297 199.766 83.0466 174.906C72.3849 166.452 71.1871 160.736 78.4518 149.393C88.8705 133.123 96.2211 115.433 103.349 97.6131C113.167 73.3251 77.6386 110.349 70.6756 112.973C39.8216 135.633 6.12115 154.639 -22.4056 180.315C-24.1783 182.073 -27.6574 184.599 -25.503 187.251C-1.62186 195.067 23.1535 201.631 46.8823 210.577C54.967 215.467 66.1696 211.417 72.9686 217.561C75.1055 220.972 70.3642 223.329 71.0495 226.883C71.2964 228.167 69.8819 230.439 68.5924 231.25C51.2263 240.953 37.2953 256.101 21.8463 267.692C14.9467 266.805 16.8884 275.407 12.6215 278.064C3.26974 287.355 -7.59312 293.929 -14.4576 305.322C-40.6786 335.84 -73.6508 364.771 -90.5758 401.199C5.44858 347.732 106.259 295.719 197.713 234.755ZM38.0362 229.585C19.9077 213.669 -52.1818 216.488 -49.6965 186.54C-35.8914 139.824 100.065 75.4789 144.025 38.9173C147.556 36.7264 152.403 30.5828 156.036 35.7018C158.784 39.8618 161.627 42.0605 158.138 46.2185C146.872 61.7457 134.914 76.6277 125.903 93.6556C116.143 108.563 110.638 125.311 104.579 141.881C103.195 148.122 91.4964 156.503 98.1198 162.105C129.464 181.814 164.546 195.463 197.222 213.069C203.649 217.823 218.234 219.705 216.763 229.742C214.463 242.253 197.278 252.599 186.691 259.393C172.874 272.735 155.152 280.482 139.086 290.923C76.4545 330.457 10.1196 363.458 -53.979 400.51C-74.1848 411.752 -94.9129 422.202 -115.074 433.411C-130.511 434.79 -122.472 416.929 -116.27 410.11C-75.6696 341.326 -18.0138 285.173 38.0362 229.585Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M295.226 379.469C309.554 376.911 361.21 474.984 328.021 444.975C322.294 437.031 273.781 380.982 295.226 379.469Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M31.6963 438.145C32.6253 428.088 47.0765 371.968 60.3487 381.276C72.6519 392.687 46.9984 432.985 41.6619 447.435C35.5304 452.911 31.7539 443.124 31.6963 438.145Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M250.46 415.027C234.887 419.585 224.749 387.225 215.774 377.08C212.355 368.943 200.353 358.842 206.122 350.018C208.83 348.425 213.513 345.676 215.925 349.143C230.784 369.128 240.229 392.412 250.46 415.027Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M-41.0263 70.5806C32.8771 79.0869 -67.1499 90.2617 -87.0259 88.3968C-104.311 72.9634 -49.6861 71.5445 -41.0263 70.5806Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M143.913 398.177C139.749 411.27 141.833 435.506 133.605 444.955C119.38 439.942 124.332 397.828 129.539 385.669C139.62 375.343 144.389 388.325 143.913 398.177Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M-10.4197 0.129395C-1.86578 1.01388 44.3936 5.57251 33.2526 19.9899C23.5201 24.2598 -50.8887 5.23962 -10.4197 0.129395Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M204.592 104.345C212.581 84.4315 242.036 140.089 243.905 148.945C235.313 152.834 203.801 114.922 204.592 104.345Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M344.144 257.358C331.711 255.4 271.719 198.879 315.213 219.137C324.126 226.789 348.611 245.003 344.144 257.358Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M193.836 461.343C195.543 512.378 172.313 449.858 177.468 433.028C189.816 405.43 193.734 452.702 193.836 461.343Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M280.232 306.51C295.491 313.288 310.985 327.145 318.465 341.889C307.898 347.801 256.992 312.585 280.232 306.51Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M116.907 -13.807C107.353 2.70255 70.629 -8.41559 68.5664 -23.3715C75.5662 -38.6127 103.905 -15.4724 116.907 -13.807Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M379.114 300.683C391.335 297.839 423.018 347.158 410.888 347.087C406.593 338.255 361.067 305.354 379.114 300.683Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M157.233 301.519C162.69 299.371 166.769 302.009 167.018 307.74C166.712 316.126 172.053 326.855 167.496 334.124C158.808 337.902 136.946 295.605 157.233 301.519Z",
				fill: "white",
				fillOpacity: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M244.739 238.145C244.838 228.204 251.779 226.482 257.302 234.86C261.473 242.164 276.772 252.015 273.853 260.306C271.28 261.46 269.872 259.287 268.095 258.243C260.739 251.963 244.169 249.596 244.739 238.145Z",
				fill: "white",
				fillOpacity: .8
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_353_7724",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 605,
			height: 541,
			fill: "white",
			transform: "translate(-191 -60)"
		})
	}) })]
});
export default SvgDownload5;
